import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { formatDate } from "../constants/rox";

const Kpi = ({ label, value, testId }) => (
  <div className="panel p-3" data-testid={testId}>
    <p className="eyebrow">{label}</p>
    <p className="mt-1 font-display text-3xl text-rox-orange">{value}</p>
  </div>
);

export const AdminStats = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);
  if (!stats) return null;
  const { totals, races } = stats;
  return (
    <section className="mt-2" data-testid="admin-stats">
      <h2 className="h-display text-3xl">Pilotage <span className="text-rox-orange">du lancement</span></h2>
      <div className="mt-4 grid grid-cols-3 gap-2">
        <Kpi label="Comptes" value={totals.users} testId="stat-users" />
        <Kpi label="Intérêts" value={totals.interests} testId="stat-interests" />
        <Kpi label="Matchs" value={totals.matches} testId="stat-matches" />
      </div>
      <div className="panel mt-3 overflow-hidden" data-testid="admin-stats-table">
        <div className="grid grid-cols-[1fr_auto_auto_auto] gap-x-3 border-b border-rox-line px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.14em] text-rox-muted">
          <span>Course</span><span className="text-right">Inscrits</span><span className="text-right">Intérêts</span><span className="text-right">Matchs</span>
        </div>
        {races.map((r) => (
          <div key={r.id} data-testid={`stat-race-${r.id}`} className="grid grid-cols-[1fr_auto_auto_auto] items-center gap-x-3 border-b border-rox-line/60 px-3 py-2.5 last:border-b-0">
            <div className="min-w-0">
              <p className="truncate font-display text-base uppercase">{r.name}</p>
              <p className="text-[11px] text-rox-muted">{r.date ? formatDate(r.date) : "Sans date"}{r.demo_athletes ? ` · ${r.demo_athletes} démo` : ""}</p>
            </div>
            <span className="text-right font-display text-lg">{r.real_athletes}</span>
            <span className="text-right font-display text-lg">{r.interests}</span>
            <span className="text-right font-display text-lg text-rox-orange">{r.matches}</span>
          </div>
        ))}
      </div>
      <p className="mt-2 text-[11px] text-rox-muted">Inscrits = vrais comptes (profils démo indiqués à part). Matchs = paires uniques.</p>
    </section>
  );
};
